import factory from './icon';
import Svg24x24 from './glyphs/Menu_24x24.svg';

export const Menu24x24 = factory(Svg24x24, 24, 24);